<template>
  <div style="height: 100%;">
    <page v-if="$route.path === '/service/strategy'">
      <ZuiHeader/>
      <SubPageTemplate page-title="达人攻略" :pid="$cid.intro.daRenGongLue" :ext1-empty="false" :page-size="6"
                       type="article" banner-type="daRenGongLue" :tag="true"
                       :video-mask="false" @article-click="articleClick"></SubPageTemplate>
      <ZuiFooter/>
    </page>
    <router-view v-else></router-view>
  </div>
</template>
<script>
import SubPageTemplate from "~/components/template/SubPageTemplate.vue";

export default {
  components: {
    SubPageTemplate
  },
  data() {
    return {
      pid: null,
      tabId: ''
    }
  },
  created() {
    this.tabId = this.$route.query.id;
  },
  mounted: function() {
			localStorage.removeItem('article_pid');
			localStorage.removeItem('article_pname');
	},
  methods: {
    articleClick(item) {
      this.$openNewWindow('/new/service/strategy/info?id=' + item.id);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/service/strategy.vue